import { render, staticRenderFns } from "./CategoryMenuFoodCardDetails.vue?vue&type=template&id=b8aff0ee&scoped=true"
import script from "./CategoryMenuFoodCardDetails.vue?vue&type=script&lang=js"
export * from "./CategoryMenuFoodCardDetails.vue?vue&type=script&lang=js"
import style0 from "./CategoryMenuFoodCardDetails.vue?vue&type=style&index=0&id=b8aff0ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8aff0ee",
  null
  
)

export default component.exports